import { theme } from '@apeiron/temp'

export default theme
